import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { MENU_DATA } from '../data/menuData';
import toast from 'react-hot-toast';

export default function Recipes() {
  const [inv, setInv]           = useState([]);
  const [recipes, setRecipes]   = useState({});
  const [editItem, setEditItem] = useState(null);
  const [ings, setIngs]         = useState([]);

  useEffect(()=>{
    getDocs(collection(db,'inventory')).then(s=>setInv(s.docs.map(d=>({id:d.id,...d.data()}))));
    getDocs(collection(db,'recipes')).then(s=>{ const r={}; s.forEach(d=>r[d.id]=d.data().ingredients||[]); setRecipes(r); });
  },[]);

  const openEdit=(item)=>{ setEditItem(item); const r=recipes[item.id]||[]; setIngs(r.length?r.map(x=>({...x})):[{matId:inv[0]?.id||'',qty:''}]); };
  const save=async()=>{
    const valid=ings.filter(i=>i.matId&&+i.qty>0);
    await setDoc(doc(db,'recipes',editItem.id),{ingredients:valid});
    setRecipes(r=>({...r,[editItem.id]:valid}));
    toast.success('Recipe saved!'); setEditItem(null);
  };

  return (
    <div>
      <p style={{ fontSize:13, color:'#888', marginBottom:14 }}>Define raw material usage per menu item per serving.</p>
      {MENU_DATA.map(item=>{
        const rec=recipes[item.id]||[];
        return (
          <div key={item.id} className="card" style={{ marginBottom:9, display:'flex', justifyContent:'space-between', alignItems:'center', padding:'11px 15px' }}>
            <div>
              <div style={{ fontWeight:500, fontSize:13 }}>{item.emoji} {item.name} <span style={{ color:'#aaa', fontWeight:400 }}>({item.cat})</span></div>
              <div style={{ marginTop:5, display:'flex', flexWrap:'wrap', gap:4 }}>
                {rec.length?rec.map((r,i)=>{ const m=inv.find(x=>x.id===r.matId); return m?<span key={i} className="tag tag-blue">{m.name}: {r.qty} {m.unit}</span>:null; }):<span style={{ fontSize:12, color:'#bbb' }}>No recipe defined</span>}
              </div>
            </div>
            <button className="btn" style={{ fontSize:12, padding:'4px 10px' }} onClick={()=>openEdit(item)}>✏ Edit</button>
          </div>
        );
      })}
      {editItem && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Recipe: {editItem.name}</h3>
            {ings.map((ing,idx)=>(
              <div key={idx} style={{ display:'flex', gap:8, marginBottom:8 }}>
                <select className="input" style={{ flex:2 }} value={ing.matId}
                  onChange={e=>setIngs(p=>p.map((x,i)=>i===idx?{...x,matId:e.target.value}:x))}>
                  {inv.map(m=><option key={m.id} value={m.id}>{m.name} ({m.unit})</option>)}
                </select>
                <input className="input" type="number" step="0.001" placeholder="qty" style={{ flex:1 }} value={ing.qty}
                  onChange={e=>setIngs(p=>p.map((x,i)=>i===idx?{...x,qty:e.target.value}:x))} />
                <button className="btn" style={{ padding:'4px 8px' }} onClick={()=>setIngs(p=>p.filter((_,i)=>i!==idx))}>✕</button>
              </div>
            ))}
            <button className="btn" style={{ fontSize:12, marginBottom:12 }}
              onClick={()=>setIngs(p=>[...p,{matId:inv[0]?.id||'',qty:''}])}>+ Add ingredient</button>
            <div style={{ display:'flex', gap:8 }}>
              <button className="btn" style={{ flex:1 }} onClick={()=>setEditItem(null)}>Cancel</button>
              <button className="btn btn-primary" style={{ flex:1 }} onClick={save}>Save Recipe</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}